// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608062204/js/" + chunkId + "." + {"44":"aa7162f6","225":"27635742","481":"da20cf99","486":"c13fd2af","770":"46f40fd6"}[chunkId] + ".0.19561580761866137.chunk.js";
};